module.exports = __webpack_public_path__ + "productivityIco.png?2369d57bacaedc52de926c97ef1615c6";